module.exports = __webpack_public_path__ + "static/media/asuminen.b0a83698.jpg";